<template>
  <div>
    <el-dialog :title="$t('system.update_role')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" class="diglog-card" width="800px" @close="initData">
      <el-form ref="form" :model="form" label-width="150px" :rules="rules" label-position="left">
        <div class="assign-role-container">
          <div class="assign-role-container-left">
            <div class="section-title">{{ $t('system.authority') }}</div>
            <div class="section-tip">{{ $t('tips.following_permission_granted_role') }}</div>
            <SystemMchMenu
              :menu-list="menuList"
              :auth-list="form.role_auths"
              :locked-code-list="locked_code_list"
              :modal-flag="modalFlag"
            />
          </div>
          <div class="assign-role-container-right">
            <div class="section-title">{{ $t('system.role_details') }}</div>
            <div class="section-tip">{{ $t('tips.manage_details_new_role') }}</div>
            <el-form-item :label="$t('system.role_name')" prop="role_name" required>
              <el-input v-model="form.role_name" size="small" placeholder="Enter Role Name" class="search-frame" autocomplete="off" clearable disabled />
            </el-form-item>
            <el-form-item :label="$t('system.remark')" prop="remark">
              <el-input v-model="form.remark" size="small" placeholder="Enter your message here" class="search-frame" autocomplete="off" clearable disabled />
            </el-form-item>

            <div slot="footer" class="dialog-footer-fixed">
              <el-button type="primary" plain class="btn-diglog-control" @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
              <el-button class="btn-diglog-control" type="primary" :disabled="listLoading" @click="submitUpdateRole('form')">{{ $t('components.submit') }}</el-button>
            </div>
          </div>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { updateMchRole } from '@/api/system/system'
export default {
  name: 'updateRoleModal',
  components: {
    SystemMchMenu: () => import('../System/SystemBaseMenu')
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        role_id: '',
        role_name: '',
        remark: '',
        role_auths: []
      },
      locked_code_list: [],
      // cities: cityOptions,
      modalFlag: 2,
      rules: {},
      isIndeterminate: true,
      checkAll: false
    }
  },
  mounted() {
    this.$bus.off('UPDATE_CHECK_AUTH_MODIFY_MODAL')
    this.$bus.on('UPDATE_CHECK_AUTH_MODIFY_MODAL', (value) => {
      this.form.role_auths = JSON.parse(JSON.stringify(value))
    })
  },
  methods: {
    changeModalStatus(status, row) {
      this.dialogUserVisible = status
      this.form = {
        role_id: row.id,
        role_name: row.role_name,
        remark: row.remark,
        role_auths: row.auth_codes
      }
      this.modalFlag = 2
      if (row && row.role_name === 'Admin(Default)') {
        this.modalFlag = 4
      }
      if (this.modalFlag === 2 || this.modalFlag === 4) {
        this.locked_code_list = row.auth_codes
      }
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    initData() {
      this.form = {
        role_id: '',
        role_name: '',
        remark: '',
        role_auths: []
      }
    },
    submitUpdateRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const params = {
              role_id: this.form.role_id,
              auth_codes: this.form.role_auths
            }
            updateMchRole(params).then(res => {
              this.$message.success('Success')
              this.$emit('updateRoleList')
              this.dialogUserVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    },
    handleCheckAllChange() {

    },
    handleCheckedChange() {

    }
  }
}
</script>

<style scoped>
.assign-role-container ::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label{
  color: #488CE8;
}

.assign-role-container  ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #488CE8;
  border-color: #488CE8;
}
.assign-role-container  ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color: #FFF;
}
.assign-role-container{
  width: 100%;
  display: flex;
}
.assign-role-container-left{
  position: relative;
  margin: -24px;
  padding: 24px;
  width: 350px;
  margin-right: 24px;
  background: rgba(72, 140, 232, 0.10);

}
.assign-role-container-right{
  flex: 1;
  position: relative;
}
.role-name-item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.role-name-item-text{
  color: #364250;
  font-size: 14px;
  font-weight: bold;
}

.dialog-footer-fixed{
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
